export default __webpack_public_path__ + "static/media/takePhoto.3cc6ee9e.svg";